module.exports = __webpack_public_path__ + "img/r-cb6-000.334f282b.gif";